
// export const PUBLIC_DATA_24H = 'https://00h30mwnvi.execute-api.eu-central-1.amazonaws.com/dev/widget/water/ugw/UGW_WATER_BORUCINO?m=temp,do,ec,ph,turbidity'
export const PUBLIC_DATA_24H = 'https://00h30mwnvi.execute-api.eu-central-1.amazonaws.com/dev/widget/water/ugw/UGW_WATER_BORUCINO?m=temp,do'
// export const PUBLIC_DATA_7D = 'https://00h30mwnvi.execute-api.eu-central-1.amazonaws.com/dev/widget/water/ugw/UGW_WATER_BORUCINO?m=temp,do,ec,ph,turbidity&from=-7d'
export const PUBLIC_DATA_7D = 'https://00h30mwnvi.execute-api.eu-central-1.amazonaws.com/dev/widget/water/ugw/UGW_WATER_BORUCINO?m=temp,do&from=-7d'

/*
  Fill missing values taking last value or 0 if its first
  array: [{meta: '24.07.2023 14:00', timestamp: 1690200000000, value: 9.470000267028809}, ...]
 */
export const fillMissingValues = (chartData, measurements) => {
  let lastSeenValue = null;
  measurements.forEach(m => {
    lastSeenValue = null;

    if (!chartData[m]) return;

    chartData[m] = chartData[m].map(([timestamp, value], idx, wholeList) => {
      if (value == null) {
        if (wholeList[Math.max(0, idx - 1)][1]) {
          lastSeenValue = wholeList[Math.max(0, idx - 1)][1];
        }
        return [timestamp, wholeList[Math.max(0, idx - 1)][1] || lastSeenValue || 0.5];
      } else {
        return [timestamp, value];
      }
    })
  })
  return chartData;
}
export function median(arr) {
  // Median
  arr.sort((a, b) => a - b);
  let median;
  let len = arr.length;
  if (len % 2 === 0) { // even
    let mid = len / 2;
    median = (arr[mid - 1] + arr[mid]) / 2;
  } else { // odd
    let mid = (len - 1) / 2;
    median = arr[mid];
  }

  return median;
}

export const MEASUREMENT_LABEL = {
  temp: "TEMP WODY",
  airTemp: "TEMP POW.",
  do: "TLEN",
  ph: "Ph",
  turbidity: "MĘTNOŚĆ",
  ec: "PRZEWODNOŚC"
}

export const MAX_VALUES = {
  temp: 30,
  airTemp: 40,
  do: 14,
  ph: 14,
  turbidity: 1500,
  ec: 5
}

export const UNITS = {
  temp: '°C',
  airTemp: '°C',
  do: 'mg/L',
  ph: '',
  turbidity: 'NTU',
  ec: 'µS/cm'
}

export const readSafe = (chartData, m) => chartData[m] ? chartData[m][chartData[m].length-1][1].toFixed(1) : null;
